<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label
      :for="inputId"
      class="control-label"
    >{{ inputLabel }}</label>
    <v-select
      v-model="inputValue"
      autocomplete="off"
      transition=""
      type="text"
      label="name"
      :filter="customFilter"
      :disabled="disabled"
      :id="inputId"
      :options="stsTypes"
      :reduce="x => x.name"
      :taggable="taggable"
      :push-tags="true"
      :create-option="createOption"
    >
      <span slot="no-options">Тип ТС по СТС не найден. <br>Можете ввести тип вручную.</span>
      <template #open-indicator="{ attributes }">
        <svg width="14" height="8" xmlns="http://www.w3.org/2000/svg" v-bind="attributes">
          <path stroke="null" id="svg_1" d="m10.838366,0.093268l-4.59,4.58l-4.59,-4.58l-1.41,1.41l6,6l6,-6l-1.41,-1.41z"/>
        </svg>
      </template>
    </v-select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import VSelect from 'vue-select'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import transportInputMixin from '../../../../mixins/application-form/transportInputMixin'

export default {
  name: 'TransportTypeFromStsInput',

  components: {
    VSelect
  },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    transportInputMixin
  ],

  props: {
    taggable: {
      type: Boolean,
      default: false
    },

    inputLabel: {
      default: 'Тип ТС (по СТС)'
    },

    inputName: {
      default: 'sts-type'
    },

    stsTypes: {
      type: Array,
      default: () => [],
      required: true
    },

    typeaheadItemKey: {
      default: 'name'
    }
  },

  computed: {
    inputId () {
      return `form-visitor-transport-${this.inputName}-${this.visitorIndex}-${this.transportIndex}`
    }
  },

  methods: {
    customFilter(stsTypes, search) {
      return stsTypes.filter(stsType => stsType.name.toLowerCase().startsWith(search.toLowerCase()))
    },

    createOption(newOption) {
      newOption = { name: newOption }
      this.$emit('option:created', newOption)

      return newOption
    }
  }
}
</script>
